import { Dialog as MDialog, styled } from '@mui/material';

export const Dialog = styled(MDialog, {
  shouldForwardProp: (prop) => prop !== 'mobileApp',
})<{ mobileApp: boolean; fullScreen?: boolean }>(({ mobileApp, fullScreen, theme }) => ({
  '& .MuiBackdrop-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(4px)',
  },
  '& .MuiPaper-root': {
    padding: mobileApp ? '20px 20px 8px' : '26px 32px 20px',
    borderRadius: mobileApp ? '20px 20px 0 0' : '16px',
    margin: mobileApp ? '0' : undefined,
    width: mobileApp ? '100%' : undefined,
    maxWidth: mobileApp ? '100%' : undefined,
    maxHeight: fullScreen ? undefined : mobileApp ? '90vh' : 'calc(100% - 64px)',
    position: mobileApp ? 'absolute' : undefined,
    bottom: mobileApp ? 0 : undefined,
    gap: '8px',
    boxShadow: mobileApp ? '0px -8px 32px rgba(0, 0, 0, 0.2)' : theme.shadows[24],
  },
}));

export const HandleBar = styled('div')(({ theme }) => ({
  width: '36px',
  height: '4px',
  borderRadius: '2px',
  backgroundColor: theme.palette.divider,
  margin: '0 auto 12px',
}));

export const Header = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  paddingBottom: '8px',
}));

export const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflow: 'hidden',
});

export const Content = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mobileApp',
})<{ mobileApp: boolean }>(({ mobileApp }) => ({
  margin: mobileApp ? '12px 0' : '20px 10px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  flex: 1,
  overflowY: 'auto',
  paddingRight: mobileApp ? '4px' : undefined,
}));

export const ButtonsWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mobileApp',
})<{ mobileApp: boolean }>(({ mobileApp, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: mobileApp ? 'center' : 'flex-end',
  gap: mobileApp ? '12px' : '16px',
  padding: mobileApp ? '8px 0 12px' : '16px 0',
  width: mobileApp ? '100%' : undefined,
  backgroundColor: theme.palette.background.paper,
}));
